import { render, staticRenderFns } from "./promotionUrl.vue?vue&type=template&id=fca5b4ca&scoped=true&"
import script from "./promotionUrl.vue?vue&type=script&lang=js&"
export * from "./promotionUrl.vue?vue&type=script&lang=js&"
import style0 from "./promotionUrl.vue?vue&type=style&index=0&id=fca5b4ca&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca5b4ca",
  null
  
)

export default component.exports